import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '@/store/auth'
import { releasesApi } from './releasesApi'

export const pendingReleaseKey = (userId: string | undefined) => ['releases', 'pending', userId] as const

/** Both announcement surfaces share one request, scoped to the signed-in account. */
export function usePendingRelease() {
  const userId = useAuthStore((s) => s.user?.id)
  return useQuery({ queryKey: pendingReleaseKey(userId), queryFn: releasesApi.pending, enabled: Boolean(userId), staleTime: 5 * 60_000, refetchOnWindowFocus: true })
}
